import { useTranslation } from 'react-i18next'
import MaterialIcon from '../ui/MaterialIcon'

export type AppTabId = 'coach' | 'meals' | 'shopping' | 'profile'

type Tab = { id: AppTabId; labelKey: string; icon: string }

const TABS: Tab[] = [
  { id: 'coach', labelKey: 'common.tabs.coach', icon: 'exercise' },
  { id: 'meals', labelKey: 'common.tabs.meals', icon: 'restaurant' },
  { id: 'shopping', labelKey: 'common.tabs.shopping', icon: 'shopping_cart' },
  { id: 'profile', labelKey: 'common.tabs.profile', icon: 'person' },
]

type BottomTabBarProps = {
  active: AppTabId
  onChange: (tab: AppTabId) => void
}

const BottomTabBar = ({ active, onChange }: BottomTabBarProps) => {
  const { t } = useTranslation()

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 flex h-16 border-t border-kilo-border bg-kilo-card/95 backdrop-blur-md">
      {TABS.map((tab) => {
        const isActive = active === tab.id
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange(tab.id)}
            className={`group flex h-16 flex-1 flex-col items-center justify-center gap-0.5 text-[11px] transition-colors ${
              isActive ? 'text-kilo-accent' : 'text-kilo-soft'
            }`}
          >
            <MaterialIcon name={tab.icon} filled={isActive} hoverable={!isActive} size="md" />
            <span className={isActive ? 'font-medium' : ''}>{t(tab.labelKey)}</span>
          </button>
        )
      })}
    </nav>
  )
}

export default BottomTabBar
